<template>
  <thead class="bg-gray-50">
    <tr>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        Recipient
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-left w-1/2"
      >
        Status
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider w-32 text-left"
      >
        Open
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-left"
      ></th>
    </tr>
  </thead>
</template>

<script>
export default {};
</script>
